type FreshChatWebsiteType = "SKYEXCHANGE247"
type OtherChatWebsiteType = "SKYEXCHANGE" | "SKYFAIR" | "MAZAPLAY"

interface FreshChatConfig {
  token: string
  host: string
  siteId: string
  tags: string[]
  faqTags?: {
    tags: string[]
    filterType: string
  }
  config: {
    headerProperty: {
      appName: string
      appLogo: string
      backgroundColor: string
    }
    cssNames?: {
      widget: string
    }
    content: {
      headers: {
        chat: string
        csat_question: string
      }
    }
  }
}

declare global {
  interface Window {
    fcWidget: {
      init: (config: FreshChatConfig) => void
    }
  }
}

const otherChatConfig = {
  SKYEXCHANGE: {
    src: "//eu.fw-cdn.com/12710015/709222.js"
  },
  SKYFAIR: {
    src: "//fw-cdn.com/11458354/4126194.js"
  },
  MAZAPLAY: {
    src: "//in.fw-cdn.com/30596534/325224.js"
  }
}

export const useChat = async () => {
  const websiteInfoStore = useWebsiteInfoStore()
  const { state } = storeToRefs(websiteInfoStore)

  const websiteSettingStore = useWebsiteSettingStore()
  const { updateIsLiveChatSite } = websiteSettingStore

  const config: Record<FreshChatWebsiteType, FreshChatConfig> = {
    SKYEXCHANGE247: {
      token: "1f5e3421-5b37-4d03-92b1-a35c3af031a6",
      host: "https://wchat.eu.freshchat.com",
      siteId: "sky247",
      tags: ["sky247"],
      faqTags: {
        tags: ["sky247"],
        filterType: "category"
      },
      config: {
        headerProperty: {
          appName: "Sky247",
          appLogo:
            "https://fc-euc1-00-pics-bkt-00.s3.amazonaws.com/f0f73422b902f382b9c258095c764478f1d8c256e8ebc1496354890da5e13f39/f_marketingpicFull/u_dc631bc274e80290917057050014b27b8a86137fced9876d2b36021338cb085d/img_1599650401805.png",
          backgroundColor: "#797979"
        },
        cssNames: {
          widget: "custom_fc_frame"
        },
        content: {
          headers: {
            chat: "Sky247",
            csat_question:
              "kya aap aaj hamaare saath ki gayi baat cheet ke anubhav se santusht the?"
          }
        }
      }
    }
  }

  function isValidFreshChatWebsiteType(value: string): value is FreshChatWebsiteType {
    return ["SKYEXCHANGE247"].includes(value)
  }

  function isValidOtherChatWebsiteType(value: string): value is OtherChatWebsiteType {
    return ["SKYEXCHANGE", "SKYFAIR", "MAZAPLAY"].includes(value)
  }

  const init = async () => {
    const websiteType = state.value.webSiteDisplayName
    const isFreshChatType = isValidFreshChatWebsiteType(websiteType)
    const isOtherChatType = isValidOtherChatWebsiteType(websiteType)

    if (!isFreshChatType && !isOtherChatType) return

    updateIsLiveChatSite(true)

    if (isFreshChatType) {
      try {
        const { default: loadFreshChat } = await import("@/plugins/loadFreshChat")

        await loadFreshChat()

        window.fcWidget.init(config[websiteType])
      } catch (error) {
        console.warn("Failed to initialize FreshChat:", error)
      }
    } else {
      const existingScript = document.getElementById("chat")

      if (!existingScript) {
        const script = document.createElement("script")
        script.src = otherChatConfig[websiteType].src
        script.id = "chat"
        script.setAttribute("chat", "true")

        script.onload = () => {
          console.log("chat loaded")
        }
        document.body.appendChild(script)
      }
    }
  }

  await init()
}

export default useChat
